import type { ProductDisplay } from "@/Domain/ProductDisplay";
import type { ProductDisplayInCart } from "@/Domain/ProductDisplayInCart";
import type { OuKashUnionUkdProducts } from "@/Domain/OuKashUnionUkdProducts";

export const getConsumerIndustrialString = function (
  product: ProductDisplay,
  consumerString: string = "Consumer",
  industrialString: string = "Industrial",
  joinString: string = " & "
) {
  const ciArr: string[] = [];
  if (product._Consumer) ciArr.push(consumerString);
  if (product._Industrial) ciArr.push(industrialString);
  return ciArr.join(joinString);
};

export const getCertificationEndDateString = function (
  product: ProductDisplay | OuKashUnionUkdProducts
) {
  if (product.CertificationEnds && product.CertificationEnds instanceof Date)
    return product.CertificationEnds.toLocaleDateString();

  const certEndString = product.CertificationEnds as unknown as string | null;
  if (!certEndString) return "";
  const certEndUnix = Date.parse(certEndString);
  if (Number.isNaN(certEndUnix)) return "";
  return new Date(certEndString).toLocaleDateString();
};

export const getCommentString = function (product: ProductDisplay) {
  if (
    (product.Conditions && product.Conditions.trim().length > 0) ||
    (product.LabelComment && product.LabelComment.trim().length > 0)
  )
    return "Y";
  return "N";
};

export const getPackagingString = function (product: ProductDisplayInCart) {
  if (!product.ProductShipping) return "";
  if (product.ProductShipping === "p") return "Packaged";
  if (product.ProductShipping === "b") return "Bulk (Railcars or Tankers)";
  if (product.ProductShipping === "bp") return "Both";
};

export const compareProducts = function (
  firstProduct: ProductDisplay,
  secondProducts: ProductDisplay
) {
  return firstProduct.AgencyId === secondProducts.AgencyId;
};
